import { Autocomplete, styled, TextField, type AutocompleteProps } from "~/common/mui";

export type SearchInputGroupAutocompleteProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> = Omit<AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>, "renderInput"> & {
  placeholder?: string;
  label?: string;
  clearable?: boolean;
};

const StyledAutocomplete = styled(Autocomplete)({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
  },
  "&.MuiAutocomplete-hasClearIcon .MuiAutocomplete-clearIndicator": {
    visibility: "visible",
  },
}) as typeof Autocomplete;

export const SearchInputGroupAutocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({
  placeholder,
  label,
  clearable = true,
  ...props
}: SearchInputGroupAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) => {
  return (
    <StyledAutocomplete
      disableClearable={!clearable as DisableClearable}
      {...props}
      renderInput={(params) => <TextField {...params} placeholder={placeholder} label={label} variant="outlined" />}
    />
  );
};
